import { withStyles } from '@material-ui/core';

import Field from './component';
import styles from './styles';

export default withStyles(styles)(Field);
